const flowDefaults = {
    opacity: 1,
    zIndex: 420,
    resolution: 128,
    pixelValuesToColorFn: (([value]) => {
        if (value < -100) return `rgba(0,0,0,0)`;
        if (value < -30) return `#31a354`;
        if (value < -10) return `#74c476`;
        if (value < 0) return '#bae4b3';
        if (value < 10) return '#eff3ff';
        if (value < 20) return '#bdd7e7';
        if (value < 30) return '#6baed6';
        if (value < 40) return '#3182bd';
        if (value <= 100) return '#08519c';
        return `rgba(0,0,0,0)`;
    }),
    legend: [
        ['< -30', '#31a354'],
        ['-30 - -10', '#74c476'],
        ['-10 - 0', '#bae4b3'],
        ['0 - 10', '#eff3ff'],
        ['10 - 20', '#bdd7e7'],
        ['20 - 30', '#6baed6'],
        ['30 - 40', '#3182bd'],
        ['> 40', '#08519c'],
    ].map(line => ({'text': line[0], 'color': line[1]}))
}

const Flows = [
    {
        'name': 'By2030',
        'key': 'by2030',
        'id': 'by2030',
        'text': 'By 2030',
        'url': 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/flood_flows/CORDEX_RCP85_2030_rp0_30_50per_PctChange_cogeo.tif	',
        'title': 'Change in annual maximum (peak) river flows (%) by 2030',
        ...flowDefaults
    },
    {
        'name': 'By2070',
        'key': 'by2070',
        'id': 'by2070',
        'text': 'By 2070',
        'url': 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/flood_flows/CORDEX_RCP85_2070_rp0_30_50per_PctChange_cogeo.tif	',
        'title': 'Change in annual maximum (peak) river flows (%) by 2070',
        ...flowDefaults
    },
]

export default   {
    sectionText: 'Future flood flows',
    section: 'flood_flows',
    components: [
      {
        text: 'Change in annual maximum (peak) river flows (%)',
        stateProperty: 'flood_hazard',
        type: 'select',
        initialState: null,
        layerType: 'select-rasterfile',
        options: Flows.map(area => ({
            key: area.name,
            id: area.name,
            text: area.text,
            value: area.name,
        })),
        rasterfiles: Flows
      },
    ]
}